import { render, staticRenderFns } from "./updateScore.vue?vue&type=template&id=19a59682"
import script from "./updateScore.vue?vue&type=script&lang=js"
export * from "./updateScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports